module.exports = __webpack_public_path__ + "static/media/shield_blue.397b6e94.svg";